import { buildId } from "@faire/slate/lib/idUtils";
import type { IText } from "@faire/slate/private/shared/types";
import { isNotUndefined } from "@faire/typescript";

import { FORM_HELPER_UNIQUE_ID_SUFFIX } from "./consts";

interface IOptions {
  prefix: string;
  idProp?: string;
  name?: IText;
  label?: IText;
  helper?: IText;
  error?: IText | boolean;
}

export const buildFormIds = (options: IOptions) => {
  const { prefix, idProp, name, label, helper, error } = options;
  const id =
    idProp ??
    buildId(
      prefix,
      name,
      label,
      helper,
      typeof error !== "boolean" ? error : undefined
    );
  const helperId =
    isNotUndefined(helper) && isNotUndefined(id)
      ? `${id}__${FORM_HELPER_UNIQUE_ID_SUFFIX}`
      : undefined;
  return {
    id,
    helperId,
  };
};
